import React from 'react';
import { formatPrice } from '../../utils/formatterUtils';

function CategoryRow({ label, color, data }) {
  const total = data?.total || 0;
  const paid = data?.paid || 0;
  const percent = total > 0 ? (paid / total) * 100 : 0;

  const barStyle = { width: `${percent}%` };
  if (color === 'red') barStyle.background = 'var(--red)';
  if (color === 'green') barStyle.background = 'var(--green)';
  if (color === 'blue') barStyle.background = 'var(--brand)';

  return (
    <>
      <div className="cat"><span className={`dot ${color}`}></span><strong>{label}</strong><span style={{ marginLeft: 'auto', color: 'var(--muted)', fontSize: '12px' }}>{percent.toFixed(1)}%</span></div>
      <div className="catrow">
        <div className="progress"><span style={barStyle}></span></div>
        <div className="kv" style={{ marginTop: '4px' }}><span className="k">Previsto: {formatPrice(total)}</span><span className="v" style={{ fontWeight: 600, color: 'var(--muted)' }}>Imponibile pagato: {formatPrice(paid)}</span></div>
      </div>
    </>
  );
}

export default function BudgetSpesaCard({ data }) {
  if (!data) return null;
  const { totalCosts, pagato, remaining, budgetUsed, budgetCategories = {} } = data;

  return (
    <article className="card-dash budget-card card--budgetSpesa">
      <h3>Budget Vs. Spesa Effettiva <span className="h-ico"><svg viewBox="0 0 24 24"><path d="M12 1v22"/><path d="M17 5H9a3 3 0 0 0 0 6h6a3 3 0 0 1 0 6H7"/></svg></span></h3>
      <hr style={{ border: 'none', height: '1px', background: '#EEF1F5', margin: '14px 0' }} />
      <div className="card-me">
        <div className="kv"><span className="k spacing-me">Budget Totale (no costi banca)</span> <span className="v">{formatPrice(totalCosts)}</span></div>
        <div className="kv"><span className="k spacing-me">Spesa Effettiva (no costi banca)</span> <span className="v">{formatPrice(pagato)}</span></div>
        <div className="kv"><span className="k spacing-me">Rimanente</span> <span className="v" style={{ color: 'var(--accent)' }}>{formatPrice(remaining)}</span></div>
        <div className="progress progress-dark"><span style={{ width: `${budgetUsed}%` }}></span></div>
        <div className="kv"><span className="k">utilizzo Budget:</span> <span>{Math.round(budgetUsed)}%</span></div>
      </div>
      <CategoryRow label="Terreno" color="red" data={budgetCategories.terreno} />
      <CategoryRow label="Costruzione" color="amber" data={budgetCategories.costruzione} />
      <CategoryRow label="Costi Vari" color="green" data={budgetCategories.costiVari} />
      <CategoryRow label="Commercializzazione" color="green" data={budgetCategories.commercializzazione} />
      <CategoryRow label="Progettazione" color="blue" data={budgetCategories.progettazione} />
    </article>
  );
}
